<template>
  <div
    class="varning-chosen"
    :class="{ 'varning-chosen--show': notСhosen }"
    @click="setChosen()"
  >
    <svg viewBox="0 0 100 107" class="varning-chosen__icon">
      <path
        d="M44.6 106.1H32.2C14.5 106.1 0 91.1001 0 72.6001V33.8001C0 32.3001 1.2 31.1001 2.7 31.1001C4.2 31.1001 5.4 32.3001 5.4 33.8001V72.5001C5.4 88.0001 17.4 100.6 32.2 100.6H44.6C55.4 100.6 66 94.3001 69.3 85.9001C70.9 81.6001 72.7 80.1001 74.9 79.9001H75.2C75.4 79.9001 75.5 79.9001 75.8 79.9001C82.4 79.9001 92.6 75.2001 93.7 67.8001C94.6 61.0001 93.6 55.9001 90.6 52.4001C86.5 47.7001 79.5 47.0001 75.7 46.9001C75.4 46.9001 75.1 46.9001 74.8 46.9001C74.1 46.9001 73.4 46.6001 72.9 46.1001C72.4 45.6001 72.1 44.9001 72.1 44.2001V33.8001C72.1 32.3001 73.3 31.1001 74.8 31.1001C76.3 31.1001 77.5 32.3001 77.5 33.8001V41.7001C82.4 42.0001 89.8 43.4001 94.7 49.0001C98.8 53.7001 100.3 60.3001 99.1 68.7001C97.6 79.3001 85 85.2001 76.4 85.4001C75.3 85.8001 75 86.6001 74.3 87.9001H74.4C70.3 98.5001 57.7 106.1 44.6 106.1Z"
        fill="black"
      />
      <path
        d="M86.4998 57.0002C82.9998 53.0002 76.5998 53.4002 74.6998 53.7002H74.5998C72.2998 54.0002 72.2998 55.4002 72.2998 59.4002C72.2998 62.6002 72.3998 69.3002 72.3998 70.1002C72.3998 70.6002 72.4998 71.1002 72.7998 71.6002C73.1998 72.3002 73.9998 72.8002 74.7998 72.9002C76.2998 73.2002 77.6998 73.3002 78.9998 73.3002C83.7998 73.3002 87.0998 71.3002 88.0998 67.7002C89.1998 63.1002 88.6998 59.6002 86.4998 57.0002ZM82.7998 66.2002C82.3998 67.8002 79.6998 67.9002 77.7998 67.8002C77.7998 66.0002 77.7998 63.4002 77.7998 59.3002C77.7998 59.2002 77.7998 59.1002 77.7998 58.9002C79.5998 59.0002 81.4998 59.4002 82.4998 60.5002C83.5998 61.9002 83.2998 64.4002 82.7998 66.2002Z"
        fill="black"
      />
      <path
        d="M9.2998 63.7999C9.2998 68.2999 9.2998 72.7999 9.3998 74.0999C9.3998 74.1999 9.3998 74.3999 9.3998 74.4999C9.6998 76.6999 9.89981 82.2999 17.6998 90.5999C24.3998 95.7999 28.6998 95.2999 34.3998 95.2999H43.7998C49.9998 95.2999 57.2998 93.7999 62.7998 88.2999C65.3998 85.6999 67.6998 78.3999 67.9998 74.2999C68.0998 72.5999 68.0998 68.1999 68.0998 63.7999C68.0998 63.7999 55.3998 65.7999 41.1998 63.8999C23.4998 61.6999 9.2998 63.7999 9.2998 63.7999Z"
        fill="black"
      />
      <path
        d="M37.2 43.3C36.3 43.3 35.4 42.9 34.7 42.2L19.5 24.7C18.3 23.3 18.5 21.3 19.8 20.1C21.2 18.9 23.2 19.1 24.4 20.4L37.1 35L63.9 1.19998C65 -0.200019 67.1 -0.400019 68.5 0.699981C69.9 1.79998 70.1 3.89998 69 5.29998L39.7 42.1C39.1 42.9 38.2 43.3 37.2 43.3Z"
        fill="black"
      />
    </svg>
    <div class="varning-chosen__text">
      {{ $t(stepName) }}
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    notСhosen() {
      return this.$store.getters.notСhosen;
    },
    stepName() {
      return `${this.$store.getters.getActiveStep}.warning`;
    }
  },
  methods: {
    setChosen() {
      this.$store.commit('notСhosen', false);
    },
  },
};
</script>

<style lang="scss">
.varning-chosen {
  background-color: rgba(white, 0);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  border-radius: 50%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: bold;
  font-size: 0.8em;
  z-index: 2;

  transform: scale(0.8);

  pointer-events: none;
  transition: transform 300ms 150ms ease-in-out, background-color 200ms ease-out;
}

.varning-chosen--show {
  pointer-events: auto;
  transform: scale(1);
  background-color: rgba(white, 0.8);

  transition: transform 300ms ease-in-out, background-color 200ms 150ms ease-out;

  .varning-chosen__text,
  .varning-chosen__icon {
    opacity: 1;
  }
}

.varning-chosen__text,
.varning-chosen__icon {
  opacity: 0;
  transition: 350ms ease-out;
}

.varning-chosen__text {
  max-width: 70vw;
  letter-spacing: 1px;
}

.varning-chosen__icon {
  width: 3em;
  height: 3em;
  margin-bottom: 1em;
}

@media (min-width: 460.89px) {
  .varning-chosen {
    font-size: 1em;
  }

  .varning-chosen__text {
    max-width: 20em;
  }

  .varning-chosen__icon {
    width: 4em;
    height: 4em;
  }
}
</style>
